import { LEVEL_IDS, type LevelId, type WorldId } from '../ids';
import type { LevelDef, SegmentDef } from '../types';
import { OP_000, OP_000_SEGMENTS } from './op-000';
import { OP_101, OP_101_SEGMENTS } from './world-1/op-101';
import { OP_102, OP_102_SEGMENTS } from './world-1/op-102';
import { OP_103, OP_103_SEGMENTS } from './world-1/op-103';
import { OP_201, OP_201_SEGMENTS } from './world-2/op-201';
import { OP_202, OP_202_SEGMENTS } from './world-2/op-202';
import { OP_203, OP_203_SEGMENTS } from './world-2/op-203';
import { OP_301, OP_301_SEGMENTS } from './world-3/op-301';
import { OP_302, OP_302_SEGMENTS } from './world-3/op-302';
import { OP_303, OP_303_SEGMENTS } from './world-3/op-303';
import { OP_401, OP_401_SEGMENTS } from './world-4/op-401';
import { OP_402, OP_402_SEGMENTS } from './world-4/op-402';
import { OP_403, OP_403_SEGMENTS } from './world-4/op-403';

// Registry of the hand-made levels and segments (GDD §10.2). Campaign levels: OP-101 (#73), OP-102 (#98), OP-103 (#99), OP-201 (#107), OP-202 (#108), OP-203 (#112), OP-301 (#119), OP-302 (#120), OP-303 (#123), OP-401 (#131), OP-402 (#132), OP-403 (#135)...

export const LEVELS: Readonly<Record<string, LevelDef>> = { [OP_000.id]: OP_000, [OP_101.id]: OP_101, [OP_102.id]: OP_102, [OP_103.id]: OP_103, [OP_201.id]: OP_201, [OP_202.id]: OP_202, [OP_203.id]: OP_203, [OP_301.id]: OP_301, [OP_302.id]: OP_302, [OP_303.id]: OP_303, [OP_401.id]: OP_401, [OP_402.id]: OP_402, [OP_403.id]: OP_403 };

export const SEGMENTS: Readonly<Record<string, SegmentDef>> = Object.fromEntries(
  [...OP_000_SEGMENTS, ...OP_101_SEGMENTS, ...OP_102_SEGMENTS, ...OP_103_SEGMENTS, ...OP_201_SEGMENTS, ...OP_202_SEGMENTS, ...OP_203_SEGMENTS, ...OP_301_SEGMENTS, ...OP_302_SEGMENTS, ...OP_303_SEGMENTS, ...OP_401_SEGMENTS, ...OP_402_SEGMENTS, ...OP_403_SEGMENTS].map((segment) => [segment.id, segment]),
);

/** The 12 missions of the campaign (GDD §10.1), in order. The test level OP-000 is not one of them. */
export function campaignLevels(): readonly LevelId[] {
  return LEVEL_IDS;
}

/** Worlds whose three levels are all written: only these are checked for their scapular (#81). */
export const COMPLETE_WORLDS: readonly WorldId[] = [];
